<template>
    <div id="pageDashboard">
        <v-container fluid grid-list-xl>
            <v-layout row wrap>
                <v-flex pb-0 xs12>
                    <filter-row></filter-row>
                </v-flex>

                <v-flex sm5 xs12 pt-0>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <card-statistic
                                :estimatedAmount="totalProduction"
                                :reachedAmount="reachedProduction"
                                :cancelledAmount="cancelledProduction"
                                color="purple darken-3"
                                icon="fas fa-funnel-dollar"
                                title="Produção"
                                caption="pagos"
                            >
                            </card-statistic>
                        </v-flex>
                        <v-flex xs12>
                            <card-statistic
                                :estimatedAmount="totalCommission"
                                :reachedAmount="reachedCommission"
                                :cancelledAmount="cancelledCommission"
                                color="blue accent-4"
                                icon="fas fa-hand-holding-usd"
                                title="Comissões"
                                caption="geradas"
                            >
                            </card-statistic>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex pt-0 sm7 xs12 >
                    <v-widget title="Por Tipo de Produto">
                        <div slot="widget-header-action">
                            <v-switch v-model="byComissions" label="Comissões" color="blue accent-4" class="mt-4"></v-switch>
                        </div>
                        
                        <div slot="widget-content">
                            <e-chart ref="echart"
                                :path-option="[
                                    [
                                        'dataset.source', perAmountType],
                                        [
                                            'color',
                                            [
                                                color.green.base,
                                                color.indigo.base,
                                                color.amber.base,
                                                color.pink.base
                                            ]
                                        ],
                                        ['xAxis.show', false],
                                        ['yAxis.show', false],
                                        ['series[0].type', 'pie'],
                                        ['series[0].avoidLabelOverlap', true],
                                        ['series[0].radius', ['40%', '70%']
                                    ]
                                ]"
                                height="300px"
                                width="100%"
                            >
                            </e-chart>
                        </div>
                    </v-widget>
                </v-flex>

                <!--LINE-->

                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                        :title="downloads | fmtFixedInt"
                        color="yellow darken-4"
                        dense
                        icon="fas fa-download"
                        sub-title="Cliques / Downloads"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                        :title="signUpRealized | fmtFixedInt"
                        color="indigo"
                        dense
                        icon="fas fa-user-plus"
                        sub-title="Cadastros Iniciados"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                        :title="signUpApproved | fmtFixedInt"
                        color="blue darken-2"
                        dense
                        icon="fas fa-check-double"
                        sub-title="Cadastros Concluídos"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12 class="">
                    <mini-statistic
                        :title="usersWithProduction | fmtFixedInt"
                        color="green darken-1"
                        dense
                        icon="fas fa-file-signature"
                        sub-title="Clientes com Produção"
                    >
                    </mini-statistic>
                </v-flex>

                <!--LINE-->

                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                        :title="createdProposals | fmtFixedInt"
                        color="yellow darken-4"
                        dense
                        icon="fas fa-file"
                        sub-title="Propostas Solicitadas"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                        :title="contractsEntered | fmtFixedInt"
                        color="indigo"
                        dense
                        icon="fas fa-file-alt"
                        sub-title="Propostas em Banco"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                        :title="contractsPaid | fmtFixedInt"
                        color="blue darken-2"
                        dense
                        icon="fas fa-file-invoice-dollar"
                        sub-title="Contratos Pagos"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12 class="">
                    <mini-statistic
                        :title="failedContracts | fmtFixedInt"
                        color="deep-orange darken-4"
                        dense
                        icon="fas fa-ban"
                        sub-title="Propostas Rejeitadas"
                    >
                    </mini-statistic>
                </v-flex>

                <!-- LINE -->

                <p style="width: 100%; margin: 10px 0 0 15px; font-size: 22px;">Fluxo Operacional Atual</p>

                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                        :title="estContracts | fmtFixedInt"
                        color="yellow darken-4"
                        dense
                        icon="fas fa-file"
                        sub-title="Propostas na Esteira"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                        :title="cttContracts | fmtFixedInt"
                        color="indigo"
                        dense
                        icon="fas fa-file-alt"
                        sub-title="Em Andamento no Banco"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                        :title="signatureContracts | fmtFixedInt"
                        color="blue darken-2"
                        dense
                        icon="fas fa-file-signature"
                        sub-title="Aguardando Assinatura"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12 class="">
                    <mini-statistic
                        :title="pendingContracts | fmtFixedInt"
                        color="deep-orange darken-4"
                        dense
                        icon="fas fa-exclamation-triangle"
                        sub-title="Propostas com Pendências"
                    >
                    </mini-statistic>
                </v-flex>

                <!--LINE-->

                <p style="width: 100%; margin: 10px 0 0 15px; font-size: 22px;">Afiliados</p>

                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                        :title="totalAffiliates | fmtFixedInt"
                        color="yellow darken-4"
                        dense
                        icon="fas fa-users"
                        sub-title="Total de Afiliados"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                        :title="newAffiliates | fmtFixedInt"
                        color="indigo"
                        dense
                        icon="fas fa-user-plus"
                        sub-title="Novos Afiliados"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                        :title="affiliatesWithLeads | fmtFixedInt"
                        color="blue darken-2"
                        dense
                        icon="fas fa-project-diagram"
                        sub-title="Afiliados com Leads"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12 class="">
                    <mini-statistic
                        :title="affiliatesWithResult | fmtFixedInt"
                        color="green darken-1"
                        dense
                        icon="fas fa-funnel-dollar"
                        sub-title="Afiliados com Produção"
                    >
                    </mini-statistic>
                </v-flex>

                <v-flex sm12 xs12>
                    <div style="width: 100%; height: 300px; color: #000; background-color: #FFF; border-radius: 10px; overflow: hidden; padding: 20px 0;">
                        <apexchart
                            ref="commissions"
                            width="100%"
                            height="100%"
                            type="area"
                            :options="commissionChartOptions"
                            :series="commissionSeries">
                        </apexchart>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import PageClass from '@consigmais-team/vue-common/layout/defaultPage/pageClass';

    import EChart from '@consigmais-team/vue-common/components/chart/echart';
    import MiniStatistic from '@consigmais-team/vue-common/components/widgets/statistic/MiniStatistic';
    import VWidget from '@consigmais-team/vue-common/components/VWidget';
    import Material from 'vuetify/es5/util/colors';
    import BoxChart from '@consigmais-team/vue-common/components/widgets/chart/BoxChart';
    import FilterRow from '@consigmais-team/vue-common/layout/defaultPage/FilterRow';
    import moment from 'moment';
    import { StackData, SinData, monthVisitData, campaignData, locationData } from '@/api/chart';
    import CardStatistic from '@consigmais-team/vue-common/components/widgets/statistic/CardStatistic';
    import numeral from 'numeral';

    const defaultChartData = [{name: 'Sem informações', value: 0}];

    export default PageClass.extend({
        components: {
            FilterRow,
            VWidget,
            MiniStatistic,
            EChart,
            BoxChart,
            CardStatistic,
        },

        data() {
            return {
                loading: false,
                totalProduction: 0,
                reachedProduction: 0,
                cancelledProduction: 0,

                totalCommission: 0,
                reachedCommission: 0,
                cancelledCommission: 0,

                clientsReached: 0,
                contractsEntered: 0,
                contractsPaid: 0,
                contractsPending: 0,
                downloads: 0,
                signUpRealized: 0,
                signUpApproved: 0,
                usersWithProduction: 0,
                totalAffiliates: 0,
                newAffiliates: 0,
                affiliatesWithLeads: 0,
                affiliatesWithResult: 0,

                createdProposals: 0,
                failedContracts: 0,

                estContracts: 0,
                cttContracts: 0,
                signatureContracts: 0,
                pendingContracts: 0,

                echart: null,
                dataFilter: {},

                byComissions: false,
                perAmountType: defaultChartData,
                perCommissionType: defaultChartData,

                commissionChartOptions: {
                    theme: {
                        mode: 'light'
                    },
                    title: {
                        text: 'Comissões'
                    },
                    legend: {
                        markers: {
                            strokeColor: '#FFF',
                        }
                    },
                    tooltip: {
                        enabled: true
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    chart: {
                        id: 'commissions',
                        zoom: {
                            enabled: false
                        },
                        toolbar: {
                            show: false
                        },
                        sparkline: {
                            enabled: false
                        },
                        locales: [{
                            'name': 'pt-br',
                            'options': {
                                'months': ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                                'shortMonths': ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                                'days': ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
                                'shortDays': ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
                                'toolbar': {
                                    'exportToSVG': 'Download SVG',
                                    'exportToPNG': 'Download PNG',
                                    'menu': 'Menu',
                                    'selection': 'Selection',
                                    'selectionZoom': 'Selection Zoom',
                                    'zoomIn': 'Zoom In',
                                    'zoomOut': 'Zoom Out',
                                    'pan': 'Panning',
                                    'reset': 'Reset Zoom'
                                }
                            }
                        }],
                        defaultLocale: 'pt-br'
                    },
                    // colors: ['#3F51B5', '#43A047'],
                    dataLabels: {
                        enabled: false
                    },
                    grid: {
                        show: false,
                    },
                    yaxis: {
                        labels: {
                            formatter: function(value) {
                                return numeral(+value).format('$ 0,0.00');
                            },
                        },
                        show: true
                    },
                    xaxis: {
                        type: 'datetime',
                        categories: [],
                        rotateAlways: false,
                        hideOverlappingLabels: true,
                        tooltip: {
                            enabled: false
                        }
                    }
                },
                commissionSeries: [
                    {
                        name: 'R$',
                        data: []
                    },
                ],

                commissionsList: null,
                commissionCols: [
                    {
                        dataField: 'commissionDate',
                        caption: 'Período',
                        minWidth: 150
                    },
                    {
                        dataField: 'productTypeName',
                        caption: 'Tipo de Produto',
                        minWidth: 100
                    },
                    {
                        dataField: 'covenantName',
                        caption: 'Convenio',
                        minWidth: 100
                    },
                    {
                        dataField: 'amount',
                        caption: 'Valor Contrato',
                        dataType: 'number',
                        format: {
                            type: 'currency',
                            precision: 2
                        },
                        minWidth: 90
                    },
                    {
                        dataField: 'term',
                        caption: 'Prazo',
                        dataType: 'number',
                        minWidth: 90
                    },
                    {
                        dataField: 'bankChartCode', //from Contract.bankChartCode || chartId -> BankChart.code
                        caption: 'Tabela',
                        minWidth: 90
                    },
                    {
                        dataField: 'totalCommission',
                        caption: 'Comissão',
                        dataType: 'number',
                        format: {
                            type: 'currency',
                            precision: 2
                        },
                        minWidth: 90
                    },
                ],

                color: Material,
                dataset: {
                    sinData: SinData,
                    monthVisit: monthVisitData,
                    campaign: campaignData,
                    location: locationData,
                    stackData: StackData
                }
            };
        },

        watch: {
            async 'byComissions' (newValue) {
                await this.loadData(this.dataFilter);
                this.$refs.echart._props.pathOption[0][1] = newValue ? this.perCommissionType : this.perAmountType;
                this.$refs.echart.clean();
                this.$refs.echart.init();
            }
        },

        computed: {
            chartType() {
                return (this.commissions && this.commissions.length > 3) ? 'area' : 'bar';
            }
        },

        methods: {
            pageFiltersChange(filters) {
                this.dataFilter = {
                    bankId: filters.bankId ? filters.bankId : null,
                    sumType: filters.sumType,
                    covenantId: filters.covenantId ? filters.covenantId : null,
                    beginDate: filters.dateRange[0] ? filters.dateRange[0] : null,
                    endDate: filters.dateRange[1] ? filters.dateRange[1] : null,
                    affiliateId: filters.affiliateId ? filters.affiliateId : null,
                    subAffiliateId: filters.subAffiliateId ? filters.subAffiliateId : null,
                    campaignId: filters.campaignId || null,
                    productTypeId: filters.productTypeId ? filters.productTypeId : null,
                }
                this.loadData(this.dataFilter);
            },

            async loadData(filters) {

                if (!filters) {
                    let actualFilters = this.$store.getters.activePageFilters;
                    filters = {
                        bankId: actualFilters.bankId ? actualFilters.bankId : null,
                        sumType: actualFilters.sumType,
                        covenantId: actualFilters.covenantId ? actualFilters.covenantId : null,
                        beginDate: actualFilters.dateRange[0] ? actualFilters.dateRange[0] : null,
                        endDate: actualFilters.dateRange[1] ? actualFilters.dateRange[1] : null,
                        affiliateId: actualFilters.affiliateId ? actualFilters.affiliateId : null,
                        subAffiliateId: actualFilters.subAffiliateId ? actualFilters.subAffiliateId : null,
                        campaignId: actualFilters.campaignId || null,
                        productTypeId: actualFilters.productTypeId ? actualFilters.productTypeId : null,
                    };
                }

                let data = await this.$api.dataService.execute('dashboardCorban/getData', filters);
                
                if(data){
                    this.totalProduction = parseFloat(data.amountTotal);
                    this.reachedProduction = parseFloat(data.amountReached);
                    this.cancelledProduction = parseFloat(data.amountCancelled);

                    this.totalCommission = parseFloat(data.commissionTotal);
                    this.reachedCommission = parseFloat(data.commissionReached);
                    this.cancelledCommission = parseFloat(data.commissionCancelled);
                    this.perAmountType = data.perAmountType ? data.perAmountType : defaultChartData;
                    this.perCommissionType = data.perCommissionType ? data.perCommissionType : defaultChartData;

                    this.clientsReached = data.prospectiveCustomers;
                    this.contractsEntered = data.typedContracts;
                    this.contractsPaid = data.paidContracts;
                    this.contractsPending = data.pendingContracts;

                    this.downloads = data.downloads;
                    this.signUpRealized = data.signUpRealized;
                    this.signUpApproved = data.signUpApproved;
                    this.usersWithProduction = data.usersWithProduction;
                    this.totalAffiliates = data.totalAffiliates;
                    this.newAffiliates = data.newAffiliates;
                    this.affiliatesWithLeads = data.affiliatesWithLeads;
                    this.affiliatesWithResult = data.affiliatesWithResult;

                    this.createdProposals = data.createdProposals;
                    this.failedContracts = data.failedContracts;

                    this.estContracts = data.estContracts;
                    this.cttContracts = data.cttContracts;
                    this.signatureContracts = data.signatureContracts;
                    this.pendingContracts = data.pendingContracts;

                    this.$refs.commissions.updateSeries([{
                        name: 'Valor',
                        data: data.commissionChartData.totalCommission
                    }]);

                    let commissionChartDates = data.commissionChartData.date;
                    switch (filters.sumType) {
                        case 'yearly':
                            commissionChartDates = commissionChartDates.map(el => {
                                return this.$moment(el).format('YYYY');
                            });

                            this.$refs.commissions.updateOptions({
                                xaxis: {
                                    categories: commissionChartDates,
                                    labels: {
                                        format: 'yyyy'
                                    },
                                    title: {
                                        text: 'Anos'
                                    }
                                }
                            });
                            break;
                        case 'monthly':
                            commissionChartDates = commissionChartDates.map(el => {
                                return this.$moment(el).format('MMM YYYY');
                            });

                            this.$refs.commissions.updateOptions({
                                xaxis: {
                                    categories: commissionChartDates,
                                    labels: {
                                        format: 'MMM yyyy'
                                    },
                                    title: {
                                        text: 'Meses'
                                    }
                                }
                            });
                            break;
                        case 'weekly':
                            this.$refs.commissions.updateOptions({
                                xaxis: {
                                    categories: commissionChartDates,
                                    type: 'datetime',
                                    labels: {
                                        format: 'dd/MM/yyyy'
                                    },
                                    title: {
                                        text: 'Semanas'
                                    }
                                }
                            });
                            break;
                        default:
                            this.$refs.commissions.updateOptions({
                                xaxis: {
                                    categories: commissionChartDates,
                                    type: 'datetime',
                                    labels: {
                                        format: 'dd/MM/yyyy'
                                    },
                                    title: {
                                        text: 'Dias'
                                    }
                                }
                            });
                            break;
                    }

                    this.$refs.echart._props.pathOption[0][1] = this.byComissions ? this.perCommissionType : this.perAmountType;
                    this.$refs.echart.clean();
                    this.$refs.echart.init();
                }
            }
        },

        created() {
            if (!this.hasPageFilters) {
                this.createPageFilters([
                    { field: 'bankId' },
                    { field: 'covenantId' },
                    { field: 'sumType' },
                    { field: 'dateRange' },
                    { field: 'affiliateId' },
                    { field: 'subAffiliateId' },
                    { field: 'campaignId' },
                    { field: 'productTypeId' },
                ]);

                // DEFAULTS FILTERS
                let endDate = this.$moment().format('YYYY-MM-DD');
                let beginDate = this.$moment().format('YYYY-MM-01');
                this.setPageFilter('sumType', 'daily', 'Totalizado por Dia');
                this.setPageFilter('campaignId', null);
                this.setPageFilter(
                    'dateRange', 
                    [
                        beginDate, endDate
                    ],
                    'Entre {0} e {1}'.format(this.$moment(beginDate).format('DD/MM/YYYY'), this.$moment(endDate).format('DD/MM/YYYY'))
                );
            }

            this.loadData();
        }
    });
</script>

<style scoped>
    #PageFooter {
        background-color: transparent !important;
        background-image: linear-gradient(180deg, rgba(0, 0, 0, .86), rgba(7, 12, 19, .93)) !important;
        color: antiquewhite;
    }

   .apexcharts-tooltip {
        background: #f3f3f3;
        color: orange;
    }

    #pageDashboard {
        background-color: #EFEFEF;
        color: black;
    }

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue